import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  Avatar,
  Popover,
  Button,
} from "@mui/material";
import {
  DotsThreeOutlineVertical,
  XCircle,
  WhatsappLogo,
  Bell,
} from "@phosphor-icons/react";
import Tooltip from "@mui/material/Tooltip";
import { connect } from "react-redux";
import {
  setUserlistShow,
  EndChat,
  setExternalChatData,
} from "../../../../../Redux/Actions/actions";

import EndChatModel from "../../chat-component-model/End-chat-model";
import WhatsappModal from "../../chat-component-model/Whatsapp-model";
import Sdk from "../../../../DialerComponent/Sdk";
import { FaDisplay } from "react-icons/fa6";
import Cobrowser from "../../chat-component-model/Co-browser";
import { CoBroswseUrl } from "../../../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { BiSolidCommentX } from "react-icons/bi";

const mapStateToProps = (state) => {
  const { data, contactListData, voice } = state;
  return {
    callList: voice.callList,
    ShowContactSideBar: data.ShowContactSideBar,
    showConversationTabType: data.ShowContactSideBar,
    userlistshow: data.userlistshow,
    selectedusername: data.selectedusername,
    externalChatData: contactListData.externalChatData,
    voiceSessionId: voice.voiceSessionId,
    seletedVoiceSessionId: voice.seletedVoiceSessionId,
    showVoiceCall: voice.showVoiceCall,
  };
};
const VoiceConversationHeader = (props) => {
  const { callObj2, callmap, stopwatch1, stopwatch2, aesSocket } = props;
  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  const selectedChat = JSON.parse(localStorage.getItem("client"));
  let permission = JSON.parse(localStorage.getItem("permission"));
  const [whatsappModalDialogOpen, setwhatsappModalDialogOpen] = useState(false);
  const [notificationDialog, setnotificationDialog] = useState(false);
  const [endchatModalDialog, setendchatModalDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showcobrowse, setShowcobrowse] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const transferToWhatsappDialogClose = () => {
    setwhatsappModalDialogOpen(false);
  };

  const NotificationHandleDialogClose = () => {
    setnotificationDialog(false);
  };

  const EndChatDialogClose = () => {
    setendchatModalDialog(false);
  };

  const CobrosweData = (value) => {
    try {
      let data = {
        url: value,
        agent_id: "313007",
        tags: ["tag1", "tag2"],
        hide_selector:
          "#input1,#input2,#emailID,#empAadhaar,#uan,#cust_PAN, #mobileinfo_Pan",
      };
      axios
        .post(CoBroswseUrl, data)
        .then((res) => {
          let url = res.data.leader_link;
          var width = 500;
          var height = 400;
          var left = (window.innerWidth - width) / 2;
          var top = (window.innerHeight - height) / 2;
          window.open(
            url,
            "Popup",
            "width=" +
              width +
              ", height=" +
              height +
              ", left=" +
              left +
              ", top=" +
              top
          );
          setShowcobrowse(false);
          handleSendMsg(res.data.follower_link, "TEXT", "");
        })
        .catch((err) => {
          console.log("err", err);
        });
    } catch (error) {}
  };
  const CobrosweData2 = async (url, type) => {
    try {
      let data = {
        email: type == "Email" ? props.externalChatData.email : "",
        phonenumber: type == "Phone" ? props.externalChatData.phonenumber : "",
        url: url,
        type: type,
      };
      const header = {
        headers: {
          "Content-Type": "application/json",
          Tenantid: localStorage.getItem("TenantId"),
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      };
      const response = await axios.post(
        CoBroswseUrl + "cobrowseapi",
        data,
        header
      );
      if (response.data.status == true) {
        window.open(response.data.leader_link);
        props.setCobrowserdata(response.data.follower_link);
      } else {
        toast.warn("something went wrong");
      }
    } catch (error) {}
  };

  return (
    <>
      <Box
        sx={{
          height: "max-content",
          width: "100%",
          borderRadius: "0 7px 0 0",
          backgroundColor: "white",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
        p={1}
      >
        <Stack
          alignItems={"center"}
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          <Stack direction={"row"} sx={{ width: "100%" }}>
            {(() => {
              if (
                (selectedChat ? selectedChat.chat_session_id : "") ==
                props.voiceSessionId
              ) {
                if (props.callList.length > 0) {
                  return (
                    <Sdk
                      callObj2={callObj2}
                      callmap={callmap}
                      stopwatch1={stopwatch1}
                      stopwatch2={stopwatch2}
                      aesSocket={aesSocket}
                    />
                  );
                } else {
                  return (
                    <Stack direction={"row"} sx={{ width: "100%" }}>
                      <Stack direction={"row"} spacing={1} sx={{ flexGrow: 1 }}>
                        <Avatar
                          sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            background: "#0B3363",
                          }}
                        >
                          {props.externalChatData
                            ? props.externalChatData.unique_id
                              ? props.externalChatData.unique_id.username
                                ? props.externalChatData.unique_id.username
                                    .slice(0, 2)
                                    .toUpperCase()
                                : props.externalChatData.unique_id.phonenumber
                                    .slice(0, 2)
                                    .toUpperCase()
                              : ""
                            : ""}
                        </Avatar>
                        <Stack
                          spacing={0.1}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 600,
                              fontSize: "13px",
                            }}
                          >
                            {props.externalChatData
                              ? props.externalChatData.unique_id
                                ? props.externalChatData.unique_id.username
                                  ? props.externalChatData.unique_id.username
                                  : props.externalChatData.unique_id.phonenumber
                                : ""
                              : ""}
                          </Typography>
                        </Stack>
                      </Stack>

                      <Stack direction={"row"} alignItems={"center"}>
                        <IconButton
                          aria-describedby={id}
                          onClick={(e) => {
                            handleClick(e);
                          }}
                        >
                          <DotsThreeOutlineVertical size={17} weight="fill" />
                        </IconButton>
                        <Popover
                          sx={{
                            "& .MuiPaper-root": {
                              borderTopLeftRadius: "30px",
                              borderBottomLeftRadius: "30px",
                              borderBottomRightRadius: "30px",
                              padding: "7px",
                              width: "max-content",
                            },
                          }}
                          id={id}
                          open={open}
                          anchorEl={anchorEl}
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <Stack direction={"row"} spacing={1}>
                            {permission.map((module) => {
                              if (module.moduleName === "VOICE_INTERACTION") {
                                const value = module.screen.find(
                                  (item) =>
                                    item.screenId === "TRANSFER_WHATSAPP" &&
                                    item.read &&
                                    item.write
                                );

                                if (value) {
                                  return (
                                    <Tooltip
                                      title="Transfer to Whatsapp"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={() => {
                                          setwhatsappModalDialogOpen(true);
                                          handleClose();
                                        }}
                                      >
                                        <WhatsappLogo size={15} weight="bold" />
                                      </IconButton>
                                    </Tooltip>
                                  );
                                } else {
                                  return (
                                    <Tooltip
                                      title="Contact Admin"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton>
                                        <WhatsappLogo size={15} weight="bold" />
                                      </IconButton>
                                    </Tooltip>
                                  );
                                }
                              }
                            })}

                            {permission.map((module) => {
                              if (module.moduleName === "VOICE_INTERACTION") {
                                const value = module.screen.find(
                                  (item) =>
                                    item.screenId === "NOTIFICATION" &&
                                    item.read &&
                                    item.write
                                );

                                if (value) {
                                  return (
                                    <Tooltip
                                      title="Notification"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={() => {
                                          setnotificationDialog(true);
                                          handleClose();
                                        }}
                                      >
                                        <Bell size={15} weight="bold" />
                                      </IconButton>
                                    </Tooltip>
                                  );
                                } else {
                                  return (
                                    <Tooltip
                                      title="Contact Admin"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton>
                                        <Bell size={15} weight="bold" />
                                      </IconButton>
                                    </Tooltip>
                                  );
                                }
                              }
                            })}

                            {permission.map((module) => {
                              if (module.moduleName === "VOICE_INTERACTION") {
                                const value = module.screen.find(
                                  (item) =>
                                    (item.screenId === "COBROWSE_PURE" &&
                                      item.read &&
                                      item.write) ||
                                    (item.screenId === "COBROWSE" &&
                                      item.read &&
                                      item.write)
                                );

                                if (value) {
                                  return (
                                    <Tooltip
                                      title="Co-Browse"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={() => {
                                          setShowcobrowse(true);
                                        }}
                                      >
                                        <FaDisplay size={15} weight="bold" />
                                      </IconButton>
                                    </Tooltip>
                                  );
                                } else {
                                  return (
                                    <Tooltip
                                      title="Contact Admin"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton>
                                        <FaDisplay size={15} weight="bold" />
                                      </IconButton>
                                    </Tooltip>
                                  );
                                }
                              }
                            })}
                          </Stack>
                        </Popover>

                        {permission.map((module) => {
                          if (module.moduleName === "VOICE_INTERACTION") {
                            const value = module.screen.find(
                              (item) =>
                                item.screenId === "END_INTERACTION" &&
                                item.read &&
                                item.write
                            );

                            if (value) {
                              return (
                                <Tooltip
                                  title="End Interaction"
                                  arrow
                                  placement="top"
                                >
                                  <Button
                                    onClick={() => {
                                      if (basedOnRole.role == "Supervisor") {
                                        if (
                                          localStorage.getItem("observing") ==
                                          props.externalChatData.chat_session_id
                                        ) {
                                          props.EndChat(props.externalChatData);
                                        } else {
                                          setendchatModalDialog(true);
                                          handleClose();
                                        }
                                      } else {
                                        setendchatModalDialog(true);
                                        handleClose();
                                      }
                                    }}
                                    className="fs-12 me-1 p-2"
                                    variant="contained"
                                    disableElevation
                                    color="error"
                                    size="small"
                                    sx={{
                                      textTransform: "capitalize",
                                      minWidth: "39px",
                                    }}
                                  >
                                    <BiSolidCommentX />
                                  </Button>
                                </Tooltip>
                              );
                            } else {
                              return (
                                <Tooltip
                                  title="Contact Admin"
                                  arrow
                                  placement="top"
                                >
                                  <Button>
                                    <BiSolidCommentX />
                                  </Button>
                                </Tooltip>
                              );
                            }
                          }
                        })}
                      </Stack>
                    </Stack>
                  );
                }
              } else {
                return (
                  <Stack direction={"row"} sx={{ width: "100%" }}>
                    <Stack direction={"row"} spacing={1} sx={{ flexGrow: 1 }}>
                      <Avatar
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          background: "#0B3363",
                        }}
                      >
                        {props.externalChatData
                          ? props.externalChatData.unique_id
                            ? props.externalChatData.unique_id.username
                              ? props.externalChatData.unique_id.username
                                  .slice(0, 2)
                                  .toUpperCase()
                              : props.externalChatData.unique_id.phonenumber
                                  .slice(0, 2)
                                  .toUpperCase()
                            : ""
                          : ""}
                      </Avatar>
                      <Stack
                        spacing={0.1}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 600,
                            fontSize: "13px",
                          }}
                        >
                          {props.externalChatData
                            ? props.externalChatData.unique_id
                              ? props.externalChatData.unique_id.username
                                ? props.externalChatData.unique_id.username
                                : props.externalChatData.unique_id.phonenumber
                              : ""
                            : ""}
                        </Typography>
                      </Stack>
                    </Stack>

                    <Stack direction={"row"} alignItems={"center"}>
                      <IconButton
                        aria-describedby={id}
                        onClick={(e) => {
                          handleClick(e);
                        }}
                      >
                        <DotsThreeOutlineVertical size={17} weight="fill" />
                      </IconButton>
                      <Popover
                        sx={{
                          "& .MuiPaper-root": {
                            borderTopLeftRadius: "30px",
                            borderBottomLeftRadius: "30px",
                            borderBottomRightRadius: "30px",
                            padding: "7px",
                            width: "max-content",
                          },
                        }}
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <Stack direction={"row"} spacing={1}>
                          {permission.map((module) => {
                            if (module.moduleName === "VOICE_INTERACTION") {
                              const value = module.screen.find(
                                (item) =>
                                  item.screenId === "TRANSFER_WHATSAPP" &&
                                  item.read &&
                                  item.write
                              );

                              if (value) {
                                return (
                                  <Tooltip
                                    title="Transfer to Whatsapp"
                                    arrow
                                    placement="top"
                                  >
                                    <IconButton
                                      onClick={() => {
                                        setwhatsappModalDialogOpen(true);
                                        handleClose();
                                      }}
                                    >
                                      <WhatsappLogo size={15} weight="bold" />
                                    </IconButton>
                                  </Tooltip>
                                );
                              } else {
                                return (
                                  <Tooltip
                                    title="Contact Admin"
                                    arrow
                                    placement="top"
                                  >
                                    <IconButton>
                                      <WhatsappLogo size={15} weight="bold" />
                                    </IconButton>
                                  </Tooltip>
                                );
                              }
                            }
                          })}

                          {permission.map((module) => {
                            if (module.moduleName === "VOICE_INTERACTION") {
                              const value = module.screen.find(
                                (item) =>
                                  item.screenId === "NOTIFICATION" &&
                                  item.read &&
                                  item.write
                              );

                              if (value) {
                                return (
                                  <Tooltip
                                    title="Notification"
                                    arrow
                                    placement="top"
                                  >
                                    <IconButton
                                      onClick={() => {
                                        setnotificationDialog(true);
                                        handleClose();
                                      }}
                                    >
                                      <Bell size={15} weight="bold" />
                                    </IconButton>
                                  </Tooltip>
                                );
                              } else {
                                return (
                                  <Tooltip
                                    title="Contact Admin"
                                    arrow
                                    placement="top"
                                  >
                                    <IconButton>
                                      <Bell size={15} weight="bold" />
                                    </IconButton>
                                  </Tooltip>
                                );
                              }
                            }
                          })}

                          <Tooltip title="Co-Browse" arrow placement="top">
                            <IconButton
                              onClick={() => {
                                setShowcobrowse(true);
                              }}
                            >
                              <FaDisplay size={15} weight="bold" />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </Popover>
                      {permission.map((module) => {
                        if (module.moduleName === "VOICE_INTERACTION") {
                          const value = module.screen.find(
                            (item) =>
                              item.screenId === "END_INTERACTION" &&
                              item.read &&
                              item.write
                          );

                          if (value) {
                            return (
                              <Tooltip
                                title="End Interaction"
                                arrow
                                placement="top"
                              >
                                <Button
                                  onClick={() => {
                                    if (basedOnRole.role == "Supervisor") {
                                      if (
                                        localStorage.getItem("observing") ==
                                        props.externalChatData.chat_session_id
                                      ) {
                                        props.EndChat(props.externalChatData);
                                      } else {
                                        setendchatModalDialog(true);
                                        handleClose();
                                      }
                                    } else {
                                      setendchatModalDialog(true);
                                      handleClose();
                                    }
                                  }}
                                  className="fs-12 me-1 p-2"
                                  variant="contained"
                                  disableElevation
                                  color="error"
                                  size="small"
                                  sx={{
                                    textTransform: "capitalize",
                                    minWidth: "39px",
                                  }}
                                >
                                  <BiSolidCommentX />
                                </Button>
                              </Tooltip>
                            );
                          } else {
                            return (
                              <Tooltip
                                title="Contact Admin"
                                arrow
                                placement="top"
                              >
                                <Button>
                                  <BiSolidCommentX />
                                </Button>
                              </Tooltip>
                            );
                          }
                        }
                      })}
                    </Stack>
                  </Stack>
                );
              }
            })()}
          </Stack>
        </Stack>
      </Box>

      {whatsappModalDialogOpen && (
        <WhatsappModal
          OpenDialog={whatsappModalDialogOpen}
          handleClose={transferToWhatsappDialogClose}
        />
      )}

      {endchatModalDialog && (
        <EndChatModel
          OpenDialog={endchatModalDialog}
          handleClose={EndChatDialogClose}
        />
      )}
      {showcobrowse && (
        <Cobrowser
          OpenDialog={showcobrowse}
          handleClose={() => {
            setShowcobrowse(false);
          }}
          CobrosweData={CobrosweData}
          CobrosweData2={CobrosweData2}
          externalChatData={props.externalChatData}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {
  setUserlistShow,
  EndChat,
  setExternalChatData,
})(VoiceConversationHeader);
